import React from 'react';
import { useHistory } from 'react-router-dom';
import BackIconLogo from 'assets/svgFiles/back-icon.svg';
import './BackIcon.scss';

export const BackIcon = ({ fallback = '/courses/' }) => {
  const history = useHistory();

  const goBack = (e) => {
 e = e || window.event; // support  for IE8 and lower
 e.preventDefault(); // stop browser from doing native logic
 // window.history.go(-1) silently does nothing if this page was the
 // first entry in the tab's history (direct link, bookmark, new tab) --
 // fall back to a known route instead of leaving the user stuck.
 if (window.history.length > 1) {
   history.goBack();
 } else {
   history.push(fallback);
 }

  };

  return (
    <div>
      <img
        src={BackIconLogo}
        alt="back icon"
        onClick={(e)=>goBack(e)}
        className="back-icon"
      />
    </div>
  );
};
